// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("channels");

import ahoy from "ahoy.js";
ahoy.configure({ cookies: false });

import React from "react";
import { render } from "react-dom";
import { CssBaseline, ThemeProvider, createMuiTheme } from "@material-ui/core";
import App from "./components/App";
import { Offline as OfflineIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/react";

require.context("./jsons", true);
require.context("./images", true);

const fontFamily = ["Nunito Sans", "Inter", "Arial", "sans-serif"].join(",");

const globalTheme = createMuiTheme({
  typography: {
    fontFamily: fontFamily,
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundColor: "#1F2B7B",
          fontFamily: fontFamily,
        },
        "h1, button": {
          fontFamily: "Inter, sans-serif",
        },
        html: { WebkitFontSmoothing: "auto" },
      },
    },
  },
});

Sentry.init({
  dsn: window.SENTRY_DSN,
  release: window.SENTRY_RELEASE,
  integrations: [new OfflineIntegration(), new Integrations.BrowserTracing()],
  tracesSampleRate: 0.1,
});

document.addEventListener("DOMContentLoaded", () => {
  render(
    <ThemeProvider theme={globalTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>,

    document.body.appendChild(document.createElement("div"))
  );
});
